const productTypes = ['FBA', 'Retail', 'STS', 'Robotics'];
const carrierScacs = ['CGOJ', 'ATMI'];
module.exports = { productTypes, carrierScacs };
